const Cplus = (props) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 109.19 122.88"
      style={{ enableBackground: "new 0 0 109.19 122.88" }}
      xmlSpace="preserve"
      height={props.height}
    >
      <g>
        <path
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#00599C",
          }}
          d="M107.81,92.16c0.86-1.48,1.39-3.16,1.39-4.66V35.38c0-1.5-0.53-3.17-1.39-4.66L54.6,61.44L107.81,92.16 L107.81,92.16z"
        />
        <path
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#004482",
          }}
          d="M59.33,121.75l45.14-26.06c1.3-0.75,2.48-2.05,3.34-3.53L54.6,61.44L1.39,92.16c0.86,1.48,2.04,2.78,3.34,3.53 l45.14,26.06C52.47,123.26,56.73,123.26,59.33,121.75L59.33,121.75z"
        />
        <path
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#659AD2",
          }}
          d="M107.81,30.72c-0.86-1.48-2.04-2.78-3.34-3.53L59.33,1.13c-2.6-1.5-6.86-1.5-9.46,0L4.73,27.19 C2.13,28.69,0,32.37,0,35.38V87.5c0,1.5,0.53,3.17,1.39,4.66L54.6,61.44L107.81,30.72L107.81,30.72z"
        />
        <path
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#FFFFFF",
          }}
          d="M54.6,97.84c-20.07,0-36.4-16.33-36.4-36.4c0-20.07,16.33-36.4,36.4-36.4c12.95,0,25.03,6.97,31.52,18.19 l-15.75,9.12c-3.25-5.62-9.29-9.1-15.77-9.1c-10.04,0-18.2,8.16-18.2,18.2c0,10.03,8.16,18.2,18.2,18.2 c6.48,0,12.52-3.49,15.77-9.1l15.75,9.12C79.63,90.87,67.55,97.84,54.6,97.84L54.6,97.84z"
        />
        <polygon
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#FFFFFF",
          }}
          points="91,59.42 86.95,59.42 86.95,55.37 82.91,55.37 82.91,59.42 78.86,59.42 78.86,63.46 82.91,63.46 82.91,67.51 86.95,67.51 86.95,63.46 91,63.46 91,59.42"
        />
        <polygon
          style={{
            fillRuleEvenodd: true,
            clipRuleEvenodd: true,
            fill: "#FFFFFF",
          }}
          points="106.16,59.42 102.12,59.42 102.12,55.37 98.07,55.37 98.07,59.42 94.03,59.42 94.03,63.46 98.07,63.46 98.07,67.51 102.12,67.51 102.12,63.46 106.16,63.46 106.16,59.42"
        />
      </g>
    </svg>
  );
};

export default Cplus;
